/*
 * Homepage demo video.
 *
 * Fill ONE of the sources below (priority: Vimeo → YouTube → MP4). When all
 * are empty the hero renders a styled poster (no broken player) so the page
 * stays production-safe.
 *
 *  - VIMEO_ID:   the numeric id from vimeo.com/XXXXXXXXXX
 *  - YOUTUBE_ID: the 11-char id from youtube.com/watch?v=XXXXXXXXXXX
 *  - MP4_SRC:    a public URL (e.g. Firebase Storage / CDN) to an .mp4
 *  - POSTER_SRC: optional poster image shown before playback (recommended
 *                for Vimeo/MP4; YouTube uses its own thumbnail when empty)
 */
export const HOME_VIDEO = {
  VIMEO_ID: "1235386784",
  YOUTUBE_ID: "",
  MP4_SRC: "",
  // Vimeo oEmbed thumbnail (https://vimeo.com/api/oembed.json?url=...), 1280x720.
  // Used as the instant fallback; HomeVideo also refreshes it from oEmbed at
  // runtime so a thumbnail change in Vimeo shows up without a code change.
  POSTER_SRC:
    "https://i.vimeocdn.com/video/2213006697-770a4219f195119e09a8f690b6f77009bd7d56f164c0544bbae3aa594b1d74e2-d_1280x720",
  TITLE: "סיור במערכת Clinikit",
  // Shown as a chip next to the play label. Empty string hides it.
  DURATION: "4 דק׳",
  // Short nudge next to the hand-drawn arrow above the frame.
  HINT: "לחצו לצפייה",
};

/* Fired by the hero CTA; HomeVideo listens and starts playback + scrolls into view. */
export const HOME_VIDEO_PLAY_EVENT = "clinikit:home-video-play";
